import { Grid, Typography } from "@mui/material"
import { TFazendaPublico } from "../../../../../../../types/api/geral/pesquisar-publicos"
import DisplayNotFoundInfo from "../../../../../../../components/DisplayNotFindInfo"

export default function FazendaSection({
    fazenda
}: FazendaSectionProps) {

    if (!fazenda) return (
        <DisplayNotFoundInfo
            variant="body2"
            label="Nenhuma fazenda selecionada"
        />
    )

    return (
        <Grid container spacing={2}>
            <Grid size={{xs: 12}}>
                <Typography variant="body2">Fazenda</Typography>
                <Typography variant="body2" fontWeight="bold">{fazenda.nome}</Typography>
                <Typography variant="caption" color="text.secondary">{fazenda.cidade} - {fazenda.estado}</Typography>
            </Grid>

            <Grid size={{xs: 12, md: 6}}>
                <Typography variant="body2">Inscrição</Typography>
                <Typography variant="body2" fontWeight="bold">{fazenda.inscricao}</Typography>
            </Grid>

            <Grid size={{xs: 12, md: 6}}>
                <Typography variant="body2">Siare</Typography>
                <Typography variant="body2" fontWeight="bold">{fazenda.siare}</Typography>
            </Grid>
        </Grid>
    )
}

interface FazendaSectionProps {
    fazenda: TFazendaPublico | null
}
